interface Props {
  title: string;
  /** 부제목 설명 텍스트. 기본값: '이 작업은 되돌릴 수 없습니다.' */
  description?: string;
  /** 확인 버튼 라벨. 기본값: '확인' */
  confirmLabel?: string;
  /** 취소 버튼 라벨. 기본값: '취소' */
  cancelLabel?: string;
  /** true 이면 확인 버튼을 비활성화하고 "처리 중..." 텍스트를 표시 */
  isLoading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * 파괴적 작업(삭제, 로그아웃 등) 전 사용자 확인을 받는 모달.
 * AdminLayout(로그아웃), AdverDetail·NoticeDetail·MemberDetail(삭제)에서 공용으로 사용한다.
 */
export default function ConfirmModal({
  title,
  description = '이 작업은 되돌릴 수 없습니다.',
  confirmLabel = '확인',
  cancelLabel = '취소',
  isLoading = false,
  onConfirm,
  onCancel,
}: Props) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl p-8 max-w-md w-full mx-4 shadow-2xl">
        <div className="text-center mb-6">
          <div className="w-16 h-16 bg-text-red/10 rounded-full flex items-center justify-center mx-auto mb-4">
            <i className="fas fa-exclamation-triangle text-text-red text-2xl"></i>
          </div>
          <h3 className="text-2xl font-bold text-gray-800 mb-2">{title}</h3>
          {description && <p className="text-gray-600">{description}</p>}
        </div>
        <div className="flex space-x-3">
          <button
            onClick={onCancel}
            className="flex-1 px-4 py-3 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition-colors font-medium"
          >
            {cancelLabel}
          </button>
          <button
            onClick={onConfirm}
            disabled={isLoading}
            className="flex-1 px-4 py-3 bg-text-red text-white rounded-lg hover:bg-text-red/90 transition-colors font-medium disabled:opacity-50"
          >
            {isLoading ? '처리 중...' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
